import { useSessionMetadata } from './useSessionMetadata'

export function useCurrentCompanyUser() {
  const sessionMetadata = useSessionMetadata()

  return sessionMetadata?.currentCompanyUser
}
